import { Svg } from "common/assets";
import { EColors } from "common/styles";
import { Modal } from "components/modal";
import { Styled } from "components/Styled";
import { useState } from "react";

import {
    IconArrowLink,
    ImageCertificate,
    ImageCertificateBig,
    StyledCertificateItem,
    StyledSertificateLink,
    StyledSertificateTitle,
} from "./styled";
import { TCertificate } from "./types";

export const CertificateItem = ({ item }: { item: TCertificate }) => {
    const [modalActive, setModalActive] = useState(false)

    return (
        <StyledCertificateItem >
            <StyledSertificateTitle>
                <ImageCertificate src={`${item.src}`} alt="certificate" />
                <Styled.PBody1>{item.title}</Styled.PBody1>
            </StyledSertificateTitle>
            <StyledSertificateLink
                type='button'
                onClick={() => setModalActive(!modalActive)}
            >
                <Styled.PBody2 color={EColors.primary_200}>Переглянути</Styled.PBody2>
                <IconArrowLink src={Svg.Arrow} alt="arrow" />
            </StyledSertificateLink>
            <Modal modalActive={modalActive} setModalActive={setModalActive} >
                <ImageCertificateBig src={`${item.srcBig}`} alt='certificate' />
            </Modal>
        </StyledCertificateItem>
    );
};
